// Added by Sejune Oh on 2019-06-24
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { Theme } from '@material-ui/core'
import { Property } from 'csstype'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const styles = (theme: Theme) => ({
    FormWrapper: {
        padding: `${theme.spacing()}px 0`,
        borderTop: '1px solid rgb(99, 99, 99)',
        display: 'flex',
        '&:first-child': {
            borderTop: 'none',
        },
        '@media (max-width: 990px)': {
            flexDirection: 'column' as Property.FlexDirection,
            paddingLeft: `${theme.spacing()}px`,
            paddingRight: `${theme.spacing()}px`,
        },
    },
    FormTtitle: {
        paddingBottom: `${theme.spacing()}px` as Property.PaddingBottom<string>,
        '@media (max-width: 990px)': {
            paddingBottom: `${theme.spacing() * 2}px` as Property.PaddingBottom<string>,
        },
    },
    TextWrapper: {
        flexBasis: '30%',
        width: '30%',
        paddingTop: `${theme.spacing() / 2}px`,
        paddingRight: '24px',
        '@media (max-width: 990px)': {
            width: '100%',
            flexBasis: '100%',
            paddingRight: 0,
        },
    },
    InputWrapper: {
        flexBasis: '70%',
        width: '70%',
        '@media (max-width: 990px)': {
            flexBasis: '100%',
            width: '100%',
        },
    },
    ControlBtnWrapper: {
        padding: `${theme.spacing() / 2}px 0 ${theme.spacing() * 1.5}px 0`,
    },
    ControlTextWrapper: {
        marginBottom: `${theme.spacing() / 2}px`,
    },
    RadioBtnWrapper: {
        padding: `${theme.spacing() / 2}px ${theme.spacing()}px ${theme.spacing() / 2}px ${
            theme.spacing()
            }px`,
        width: '100%',
    },
    RadioBtnGroupWrapper: {
        flexDirection: 'row' as Property.FlexDirection,
    },
    BtnWrapper: {
        paddingLeft: `${theme.spacing()}px`,
        paddingBottom: `${theme.spacing()}px`,
    },
    CtrWrapper: {
        paddingLeft: `${theme.spacing()}px`,
    },
    ErrMsgWrapper: {
        color: 'rgba(255, 255, 255, 0.7)',
        paddingBottom: `${theme.spacing()}px`,
    },
})

export default styles
